import {HttpClient, HttpParams, HttpUrlEncodingCodec} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PageOfFilterPresetData} from 'src/app/model/filter-preset-data/page-of-filter-preset-data.model';
import {environment} from 'src/environments/environment';
import {ApplicationPackage} from '../../enums/application-package.enum';
import {Service} from '../../enums/service.enum';
import {QueryParams} from '../../model/query-models/query-models';
import {FilterPresetData} from '../../model/filter-preset-data/page-of-filter-preset-data.model';
import { CustomHttpUrlEncodingCodec } from 'src/app/main/encoder';

@Injectable({
  providedIn: 'root',
})
export class FilterPresetDataService {
  private readonly filterPresetApi = environment.endPoint + ApplicationPackage.CMS_VOD + Service.FILTER_PRESETS;

  constructor(private http: HttpClient) {}

  getAllPresets(queryParam?: QueryParams, filterPresentName?: string): Observable<PageOfFilterPresetData> {
    let queryParams = new HttpParams({encoder: new HttpUrlEncodingCodec()});

    if (queryParam.page > 0) {
      queryParams = queryParams.set('page', <any>queryParam.page);
    }

    if (queryParam.itemCount > 0) {
      queryParams = queryParams.set('itemCount', <any>queryParam.itemCount);
    }

    if (queryParam.name) {
      queryParams = queryParams.set('name', <any>queryParam.name);
    }

    if (queryParam.assetType) {
      queryParams = queryParams.set('assetType', <any>queryParam.assetType);
    }

    if (filterPresentName) {
      queryParams = queryParams.set('name', <any>filterPresentName);
    }

    return this.http.get<PageOfFilterPresetData>(this.filterPresetApi, {params: queryParams});
  }

  getFilterPresetById(presetId: number): Promise<FilterPresetData> {
    return this.http.get<FilterPresetData>(this.filterPresetApi + `/${presetId}`).toPromise();
  }

  createFilterPresetPromise(filterPresetData: FilterPresetData): Promise<FilterPresetData> {
    return this.http.post<FilterPresetData>(this.filterPresetApi, filterPresetData).toPromise();
  }

  updateFilterPresetDataPromise(filterPresetData: FilterPresetData): Promise<FilterPresetData> {
    return this.http
      .put<FilterPresetData>(this.filterPresetApi, filterPresetData, {responseType: 'text' as 'json'})
      .toPromise();
  }
  deleteById(presetId: number): Observable<string> {
    return this.http.delete<string>(this.filterPresetApi + `/${presetId}`, {responseType: 'text' as 'json'});
  }
}
